var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "form-row" }, [
      _c(
        "div",
        { staticClass: "form-group col-md-6" },
        [
          _c("label", [_vm._v("บัญชีแสดงสัญญา ")]),
          _c("span", { staticClass: "required" }, [_vm._v("*")]),
          _c("b-form-input", {
            class: { input: true, "is-danger": _vm.errors.has("caNo2") },
            attrs: { name: "caNo2", type: "text", maxlength: "12" },
            on: {
              keypress: function($event) {
                return _vm.isNumber($event)
              }
            },
            model: {
              value: _vm.caNo,
              callback: function($$v) {
                _vm.caNo = $$v
              },
              expression: "caNo"
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "form-group col-md-6" }, [
        _c("label", [_vm._v("เลขที่คำขอเงินประกัน")]),
        _c("span", { staticClass: "required" }, [_vm._v("*")]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.securityNo,
              expression: "securityNo"
            }
          ],
          staticClass: "form-control",
          class: { input: true, "is-danger": _vm.errors.has("securityNo2") },
          attrs: { name: "securityNo2", type: "text", maxlength: "10" },
          domProps: { value: _vm.securityNo },
          on: {
            keypress: function($event) {
              return _vm.isNumber($event)
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.securityNo = $event.target.value
            }
          }
        })
      ])
    ]),
    _c("div", { staticClass: "form-row" }, [
      _c("div", { staticClass: "form-group col-md-6" }, [
        _c("label", [_vm._v("หมายเลขคู่ค้าทางธุรกิจ")]),
        _c("span", { staticClass: "required" }, [_vm._v("*")]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.bpNo,
              expression: "bpNo"
            }
          ],
          staticClass: "form-control",
          class: { input: true, "is-danger": _vm.errors.has("bpNo2") },
          attrs: { name: "bpNo2", type: "text", maxlength: "10" },
          domProps: { value: _vm.bpNo },
          on: {
            keypress: function($event) {
              return _vm.isNumber($event)
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.bpNo = $event.target.value
            }
          }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }